import React, {useState} from 'react'
import styles from './Slider.module.scss'
import { useEffect } from 'reactn'

const Slider = (props) => {
  const { disabled, onChange, initialValue } = props

  const [sliderValue, setSliderValue] = useState(0.5)

  useEffect(() => {
    const iniValue = (initialValue) ? initialValue : 0.5
    setSliderValue(iniValue)
  }, [initialValue])

  const sliderChange = (event) => {
    const sliderValue = event.currentTarget.value
    if(sliderValue){
      setSliderValue(sliderValue)
    }
    onChange(sliderValue)
  }

  return (
    <div className={styles.outer}>
      <div className={styles.sliderlabel}> <b>Opacity:</b> {sliderValue}</div>

      <input type="range" min="0" max="1" step="0.1" value={sliderValue} onChange={sliderChange} className={styles.slider} disabled={!disabled}/>

    </div>
  )
}

export default Slider
